import React from 'react';

import { InfoTooltip } from './Tooltip';
import { ProductReturn } from '../pages/types';

interface ReturnsColumnProps {
  productReturn: ProductReturn | undefined;
}

const ProductReturnStatus = ({ productReturn }: { productReturn: ProductReturn }) => {
  const productReturnStatus = productReturn?.status.toLocaleLowerCase();

  const productReturnStatusColor = (productReturnStatus?: string) => {
    if (!productReturnStatus) return '';
    switch (productReturnStatus) {
      case 'processed':
        return 'text-[#008C1E]';
      case 'expired':
        return 'text-gray';
      default:
        return '';
    }
  };

  return (
    <div
      className={`flex flex-col text-center items-center ${productReturnStatusColor(
        productReturnStatus
      )}`}
    >
      <div className="flex flex-row items-center gap-1">
        <span className="text-sm">Return {productReturnStatus}</span>
        {productReturnStatus === 'expired' && (
          <InfoTooltip
            width="12"
            height="12"
            text="Customer did not drop off their return shipment within 90 days"
          />
        )}
      </div>
      {productReturnStatus === 'pending' && !productReturn.label_url && (
        <p className="text-xs">Return label generating...</p>
      )}
      {productReturnStatus === 'pending' && productReturn.label_url && (
        <a className="text-xs underline hover:cursor-pointer" href={productReturn.label_url}>
          Link to return label
        </a>
      )}
    </div>
  );
};

export const ReturnsColumn = ({ productReturn }: ReturnsColumnProps) => {
  // Product returns feature is sunset - hide "Start a return" button for all fulfillments
  // but continue to show return status for in-flight and completed returns
  return productReturn ? <ProductReturnStatus productReturn={productReturn} /> : '--';
};
